const analyticsCompanyStatus = {
    0: "Inactive",
    1: "Active"
}

export default analyticsCompanyStatus